import { initAccountMenu, initSettings } from "./account";
import { initAuth } from "./auth";
import { $ } from "./dom";
import { initPalette } from "./palette";
import { initTheme } from "./theme";

/** Progressive-enhancement entry. The site is fully usable without this script. */
async function boot(): Promise<void> {
  initTheme();
  initPalette();
  initAuth();
  initAccountMenu();
  initSettings();

  if ($("#dashboard")) {
    const { initDashboard } = await import("./dashboard");
    initDashboard();
  }

  if ($("#composer")) {
    const [{ initEditor }, { initRecentOnCreate }] = await Promise.all([
      import("./editor"),
      import("./recent"),
    ]);
    initEditor();
    initRecentOnCreate();
  }

  if ($("#paste")) {
    const { initViewer } = await import("./viewer");
    initViewer();
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => void boot());
} else {
  void boot();
}
